import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Orquestra a assinatura digital e a abertura do PDF assinado de um documento de saúde (atestado,
// receituário), compartilhado entre as listas web e mobile de cada feature.
export function useSignedDocumentActions({ fetchSignedDocumentUrl, onSuccess, onError, refetch }) {
  const navigate = useNavigate();

  const [documentToSign, setDocumentToSign] = useState(null);
  const [isOpeningSignedDocument, setOpeningSignedDocument] = useState(false);

  const openSignModal = (document) => setDocumentToSign(document);
  const closeSignModal = () => setDocumentToSign(null);

  const onSigned = (returnFromApi) => {
    setDocumentToSign(null);
    onSuccess(returnFromApi.data);
    refetch();
  };

  const openSignedDocument = (documentId) => {
    // Opens the tab synchronously so the popup blocker allows it, then points it to the signed URL.
    const documentWindow = window.open('', '_blank');
    setOpeningSignedDocument(true);
    fetchSignedDocumentUrl(documentId)
      .then((returnFromApi) => {
        if (documentWindow) {
          documentWindow.location.href = returnFromApi.data;
        } else {
          window.location.assign(returnFromApi.data);
        }
      })
      .catch((returnFromApi) => {
        documentWindow?.close();
        onError(String(returnFromApi.response?.data ?? 'Erro ao abrir o documento assinado.'));
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setOpeningSignedDocument(false));
  };

  return {
    documentToSign,
    openSignModal,
    closeSignModal,
    onSigned,
    openSignedDocument,
    isOpeningSignedDocument,
  };
}
